import types from '../mutation-types';
import {
  buildStepMaps,
  getParentSteps,
} from '../utils/wgptAutomationBuilderUtils';

export const state = {
  automation: {},
  stepMap: new Map(),
  jumpTargetMap: new Map(),
};

export const getters = {
  get($state) {
    return $state.automation ?? {};
  },
  getSteps($state) {
    const steps = $state.automation.steps?.v ?? [];
    return steps;
  },
  findStepById: $state => stepId => {
    return $state.stepMap.get(stepId) ?? null;
  },
  getLinkedSteps: $state => stepId => {
    const step = $state.stepMap.get(stepId);
    if (!step) return [];

    const linkedSteps = [...($state.jumpTargetMap.get(stepId) ?? [])];

    if (step.action === 'jump_to_step') {
      const targetStepId = step.attributes?.step_id;
      const targetStep = $state.stepMap.get(targetStepId);
      if (targetStep) linkedSteps.push(targetStep);
    }

    return linkedSteps;
  },
  getParentSteps: $state => stepId => {
    const steps = $state.automation?.steps?.v ?? [];
    const parentSteps = getParentSteps(steps, stepId);
    return parentSteps;
  },
};

export const actions = {
  set: async ({ commit }, data) => {
    commit(types.SET_WGPT_AUTOMATION_BUILDER, data);
  },
  reset: ({ commit }) => {
    commit(types.RESET_WGPT_AUTOMATION_BUILDER);
  },
};

export const mutations = {
  [types.SET_WGPT_AUTOMATION_BUILDER_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_WGPT_AUTOMATION_BUILDER]($state, data) {
    $state.automation = data;
    const steps = data?.steps?.v ?? [];
    const { stepMap, jumpTargetMap } = buildStepMaps(steps);
    $state.stepMap = stepMap;
    $state.jumpTargetMap = jumpTargetMap;
  },
  [types.RESET_WGPT_AUTOMATION_BUILDER]($state) {
    $state.automation = {};
    $state.stepMap = new Map();
    $state.jumpTargetMap = new Map();
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
